import React, { useState } from "react"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import { useOutsideClickRef } from "rooks"
import { getRoute } from "../helpers/routing"
import Logo from "./Logo"
import TopMenu from "./TopMenu"
import Menu from "./Menu"
import { TxlLink, SimpleLink } from "./TxlLink"

const LogoBar = ({ className }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("generic")

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  function closeMenu() {
    setIsMenuOpen(false)
  }

  const [ref] = useOutsideClickRef(closeMenu)

  return (
    <div className={className} ref={ref}>
      <Logo
        to={getRoute("/", language)}
        onIconClick={() => setIsMenuOpen(!isMenuOpen)}
      />
      <TopMenu $isOpen={isMenuOpen}>
        <Menu>
          <ul>
            <li>
              <TxlLink to={getRoute("/about", language)}>
                {t("##.Menu.About")}
              </TxlLink>
            </li>
            <li>
              <TxlLink to={getRoute("/plans", language)}>
                {t("##.Menu.Plans")}
              </TxlLink>
            </li>
            <li>
              <SimpleLink
                href={t("##.Menu.HowtoFaqBlogPost")}
                target="_blank"
                rel="noopener"
              >
                {t("##.Menu.HowtoFaq")}
              </SimpleLink>
            </li>
          </ul>
        </Menu>
      </TopMenu>
    </div>
  )
}

const StyledLogoBar = styled(LogoBar)`
  & ${TopMenu} {
    max-height: 400px;
    width: 200px;
    left: 0;

    ${Menu}::before {
      left: 12px;
      right: auto;
    }
  }
`

export default StyledLogoBar
